<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12">
        <h1>Holiday Request</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <h6 class="q-mt-sm q-mb-sm">Holiday Request</h6>
        <p>
          Holiday requests should be submitted providing a minimum of two week's notice, please also
          refer to the staff handbook.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-6 col-md-4">
        <v-text-field
          disabled
          filled
          hint=""
          label="First Name"
          v-model="person.first_name" />
      </v-col>
      <v-col class="col-6 col-md-4">
        <v-text-field
          disabled
          filled
          hint=""
          label="Last Name"
          v-model="person.last_name" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-8">
        <v-text-field
          disabled
          filled
          hint=""
          label="Holiday allowance per year (days)"
          v-model="person.holiday_entitlement" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <h6 class="q-mt-sm q-mb-sm">This year</h6>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-6">
        <v-text-field
          disabled
          filled
          hint=""
          label="Booked (days)"
          v-model="person.bookedDays" />
      </v-col>
      <v-col class="col-6">
        <v-text-field
          disabled
          filled
          hint=""
          label="Remaining (days)"
          v-model="person.remainingDays" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <h6 class="q-mt-sm q-mb-sm">Next year</h6>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-6">
        <v-text-field
          disabled
          filled
          hint=""
          label="Booked (days)"
          v-model="person.bookedDaysNextYear" />
      </v-col>
      <v-col class="col-6">
        <v-text-field
          disabled
          filled
          hint=""
          label="Remaining (days)"
          v-model="person.remainingDaysNextYear" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-8">
        <v-select
          filled
          hint=""
          label="Coverage"
          :items="['Full day', 'Half day']"
          v-model="request.coverage" />
      </v-col>
    </v-row>
    <v-row v-if="request.coverage === 'Half day'">
      <v-col class="col-12 col-md-8">
        <v-select
          filled
          hint=""
          label="AM or PM?"
          :items="['AM', 'PM']"
          v-model="request.am_or_pm" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-8">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="request.first_day"
                label="First day of holiday"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                suffix="*"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="startDate"
              @input="menu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row v-if="request.coverage !== 'Half day'">
      <v-col class="col-12 col-md-8">
        <v-menu
            v-model="menuTwo"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="request.last_day"
                label="Last day of holiday"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                suffix="*"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="endDate"
              @input="menuTwo = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-8">
        <v-text-field
            disable
            filled
            hint=""
            label="Total holiday duration (days)"
            v-model="request.total_days" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-8">
        <v-btn
            @click="saveRequest"
            class="full-width"
            color="purple"
            size="lg">Submit request</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="requests.length > 0">
      <v-col class="col-12">
        <h6 class="q-mt-sm q-mb-sm">Existing leave requests</h6>
        <v-simple-table>
          <thead>
          <tr>
            <th class="text-left">Start Date</th>
            <th class="text-left">End Date</th>
            <th class="text-left">Total days off</th>
            <th class="text-left">Approved?</th>
            <th class="text-left">Rejected?</th>
          </tr>
          </thead>
          <tbody>
          <tr
              :key="`er_${index}`"
              v-for="(existingRequest, index) in requests">
            <td>{{ existingRequest.first_day }}</td>
            <td>{{ existingRequest.last_day }}</td>
            <td>{{ existingRequest.total_days }}</td>
            <td>
              <span v-if="existingRequest.approved === false">No</span>
              <span v-else>Yes</span>
            </td>
            <td>
              <span v-if="existingRequest.rejected === false">No</span>
              <span v-else>Yes</span>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog
        v-model="showMessage"
        max-width="290"
    >
      <v-card>
        <v-card-text class="pt-4">
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="orange darken-2"
              text
              @click="closeMessage"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { differenceInDays } from "date-fns";
import axios from '../../../axios';

export default {
  name: 'AddLeaveRequest',
  computed: {
    token() {
      return this.$store.state.token;
    },
    userid() {
      return this.$store.state.userid;
    },
  },
  watch: {
    endDate () {
      this.request.last_day = this.formatDate(this.endDate);
    },
    startDate () {
      this.request.first_day = this.formatDate(this.startDate);
    },
    request: {
      handler() {
        this.getDuration();
      },
      deep: true,
    },
  },
  data() {
    return {
      endDate: null,
      menu: false,
      menuTwo: false,
      message: '',
      person: {
        bookedDays: 0,
        bookedDaysNextYear: 0,
        holiday_entitlement: 0,
        id: 0,
        first_name: '',
        last_name: '',
        remainingDays: 0,
        remainingDaysNextYear: 0,
      },
      proxyFirstDay: '',
      proxyLastDay: '',
      request: {
        am_or_pm: '',
        approved: false,
        coverage: '',
        exclude_bank_holiday: true,
        exclude_weekend: true,
        first_day: '',
        last_day: '',
        paid: true,
        rejected: false,
        total_days: 0,
        type: '',
      },
      requests: [],
      showMessage: false,
      startDate: null,
    };
  },
  methods: {
    closeMessage() {
      this.$router.push('/start');
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    getDuration() {
      if (this.request.first_day.length > 0 && this.request.last_day.length > 0) {
        const firstDayArray = this.request.first_day.split('-');
        const firstDay = parseInt(firstDayArray[0], 10);
        const firstMonth = parseInt(firstDayArray[1], 10);
        const firstYear = parseInt(firstDayArray[2], 10);
        const lastDayArray = this.request.last_day.split('-');
        const lastDay = parseInt(lastDayArray[0], 10);
        const lastMonth = parseInt(lastDayArray[1], 10);
        const lastYear = parseInt(lastDayArray[2], 10);
        const date1 = new Date(firstYear, firstMonth, firstDay);
        const date2 = new Date(lastYear, lastMonth, lastDay);
        const difference = differenceInDays(date2, date1);
        let daysToSubtract = 0;
        axios.post(`/utilityTools/getDays.json?token=${this.token}`, this.request)
            .then((response) => {
              daysToSubtract += response.data.days;
              this.request.total_days = ((difference - daysToSubtract) + 1);
            });
      }
      if (this.request.first_day.length > 0 && this.request.last_day.length === 0 && this.request.coverage === 'Full day') {
        this.request.total_days = 1;
      }
      if (this.request.first_day.length > 0 && this.request.last_day.length === 0 && this.request.coverage === 'Half day') {
        this.request.total_days = 0.5;
      }
    },
    getPerson() {
      axios.get(`/personnel/getHolidayInfoByUserId/${this.userid}.json?token=${this.token}`)
          .then((response) => {
            this.person = response.data.person;
            this.getRequests();
          });
    },
    getRequests() {
      axios.get(`/leaveRequests/getByPersonnelId/${this.person.id}.json?token=${this.token}`)
          .then((response) => {
            this.requests = response.data.leaveRequests;
          });
    },
    saveRequest() {
      const postData = {
        person: this.person,
        request: this.request,
      };
      axios.post(`/leaveRequests/create/false.json?token=${this.token}`, postData)
          .then((response) => {
            this.showMessage = true;
            this.message = response.data.message;
          });
    },
  },
  mounted() {
    this.getPerson();
  },
};
</script>
